// extracted by mini-css-extract-plugin
export var active = "_d0-7";
export var blink = "_d0-8";
export var dropDownSelector = "_d0-4";
export var dropDownWrapper = "_d0-3";
export var fakeCursor = "_d0-6";
export var fontSizeButton = "_d0-9";
export var formQuillEditor = "_d0-0";
export var pressed = "_d0-a";
export var qlBlank = "_d0-1";
export var textFormattingToolbar = "_d0-2";
export var textToolbarOption = "_d0-5";